// extracted by mini-css-extract-plugin
export default {"main":"mainPage_main__JWNwd"};